var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5978 21.1899L18.5011 16.0932C18.2738 15.8659 18.233 15.511 18.4041 15.2386C19.3727 13.6929 19.9285 11.8638 19.9174 9.90272C19.8876 4.4834 15.4633 0.0463226 10.0449 0.000360144C4.47659 -0.0464535 -0.0464535 4.47659 0.000360144 10.0449C0.0463226 15.4642 4.4834 19.8876 9.90272 19.9174C11.8629 19.9285 13.6929 19.3718 15.2386 18.4041C15.511 18.233 15.8659 18.273 16.0932 18.5011L21.1899 23.5978C21.7261 24.1341 22.5952 24.1341 23.1314 23.5978L23.5978 23.1314C24.1341 22.5952 24.1341 21.7261 23.5978 21.1899ZM3.40499 9.95889C3.40499 6.34488 6.34488 3.40499 9.95889 3.40499C13.5729 3.40499 16.5128 6.34488 16.5128 9.95889C16.5128 13.5729 13.5729 16.5128 9.95889 16.5128C6.34488 16.5128 3.40499 13.5729 3.40499 9.95889Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.ee8f823fd0a1527ddbf8bbae38588c78.svg";
export { ForwardRef as ReactComponent };